import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__main">
          {/* Brand */}
          <div className="footer__brand">
            <h3 className="footer__brand-name">
              Cabana <span>Buru</span>
            </h3>
            <p className="footer__brand-tagline">Where the mountains welcome you home</p>
            <p className="footer__brand-desc">
              Nestled at 1,200m in the Carpathians, our chalet offers an authentic mountain retreat
              surrounded by ancient forests and breathtaking peaks.
            </p>
          </div>

          {/* Navigation */}
          <div className="footer__col">
            <h4 className="footer__col-title">Navigate</h4>
            <ul className="footer__links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/rent">Book a Stay</Link></li>
              <li><Link to="/reviews">Reviews</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Experience */}
          <div className="footer__col">
            <h4 className="footer__col-title">Experience</h4>
            <ul className="footer__links">
              <li><Link to="/gallery">Mountain Views</Link></li>
              <li><Link to="/gallery">Forest Trails</Link></li>
              <li><Link to="/gallery">Local Cuisine</Link></li>
              <li><Link to="/gallery">Stargazing</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div className="footer__col">
            <h4 className="footer__col-title">Guest</h4>
            <ul className="footer__links">
              <li><Link to="/login">Sign In</Link></li>
              <li><Link to="/register">Register</Link></li>
              <li><Link to="/account">My Account</Link></li>
              <li><Link to="/reviews">Write a Review</Link></li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="footer__divider">
          <span className="footer__divider-line" />
          <span className="footer__divider-diamond" />
          <span className="footer__divider-line" />
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="footer__flag">
          <span /><span /><span />
        </div>
        <p className="footer__copy">&copy; 2026 Cabana Buru. All rights reserved.</p>
        <p className="footer__made">
          Made with <span className="footer__made-heart">&#9829;</span> in Romania
        </p>
      </div>
    </footer>
  );
}
